import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Dialog from "./../../UiComponents/Dialog";
import Questions from "./questions";
import styles from "./surveyView.module.scss";
import Confirmation from "./../confirmationBox";
import getLabel from './../../../utils/labels'
import tickIcon from "./../../../globals/images/survey-completed.svg";

class SurveyView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			radioButtonStyle: {
				width: "10px",
				height: "10px",
				borderRadius: "5px",
				border: "solid 1px #5472c1",
				backgroundColor: "#5472c1"
			},
			surveyAnswers: [],
			isOptionSelected: false,
			isSurveyCompleted: false,
			isErrorBoxOpen: false,
			isConfirmationOpen: false
		};
	}

	componentWillMount() {
		this.getSurveyAutoSavedAnswers();
	}

	getSurveyAutoSavedAnswers = () => {
		let surveyDetails = this.props.actionThread.find(
			item => item.type === "survey"
		);
		if (surveyDetails) {
			let tempAnswerArray = surveyDetails.answers.map(id => {
				return { questionId: id.questionId, optionId: id.optionId };
			});
			this.setState({
				surveyAnswers: tempAnswerArray
			});
		}
	};

	getInstructions = () => {
		const { survey } = this.props;
		return survey.instructions.map((inst, key) => {
			return (
				<div className={styles["instruction"]} key={key}>
					<div className={styles["bullet"]} />
					<div className={styles["instruction-text"]}>{inst}</div>
				</div>
			);
		});
	};

	getSurveyQuestions = () => {
		const { survey } = this.props;
		return survey.questions.map((question, index) => {
			return (
				<Questions
					question={question}
					key={index}
					index={index}
					surveyAnswers={this.state.surveyAnswers}
					addAnswersToArray={this.addAnswersToArray}
					saveAnswer={this.saveAnswer}
				/>
			);
		});
	};

	addAnswersToArray = answer => {
		let { surveyAnswers } = this.state;
		let newSurveyAnswers = surveyAnswers.filter(
			item => item.questionId !== answer.questionId
		);
		newSurveyAnswers = [...newSurveyAnswers, answer];

		this.setState({
			surveyAnswers: newSurveyAnswers
		});
	};

	closeSurvey = () => {
		this.props.closeSurvey();
	};

	saveAnswer = question => {
		let surveyData = {
			primaryMailId: this.props.primaryMailId,
			surveyId: this.props.survey.id,
			actionTakenAt: this.props.getTimeData().timeLeft,
			questionId: question.questionId,
			optionId: question.optionId
		};
		this.props.autoSaveSurveyAnswers(surveyData);
	};

	saveAndCloseSurvey = () => {
		this.props.setSurveyCompleteFlag({
			primaryMailId: this.props.primaryMailId
		});
		this.closeSurvey();
	};

	checkIfAllAnswersAreSelected = () => {
		return (
			this.props.survey.questions.length ===
			this.state.surveyAnswers.length
		);
	};

	sendAnswers = () => {
		this.closeConfirmationBox();
		this.setState({
			isSurveyCompleted: true
		});
	};

	openConfirmationBox = () => {
		if (this.checkIfAllAnswersAreSelected()) {
			this.setState({
				isErrorBoxOpen: false,
				isConfirmationOpen: true
			});
		} else {
			this.setState({
				isErrorBoxOpen: true
			});
		}
	};

	closeConfirmationBox = () => {
		this.setState({
			isConfirmationOpen: false
		});
	};

	closeErrorBox = () => {
		this.setState({
			isErrorBoxOpen: false
		});
	};

	render() {
		let isFooterNeeded = false,
			isCloseButtonNeeded = true;
		return (
			<Fragment>
				{!this.state.isSurveyCompleted ? (
					<Dialog
						title={this.props.survey.name}
						overlayClassName={styles.dialog}
						containerClassName={styles["overlay-container"]}
						headerClassName={styles["header"]}
						isFooterNeeded={isFooterNeeded}
						isCloseButtonNeeded={isCloseButtonNeeded}
						onClose={this.props.closeSurvey}
					>
						<div className={styles["survey-background"]}>
							<div className={styles["instructions-box"]}>
								<div className={styles["instructions-title"]}>
									{getLabel('label_survey_instructions')}
								</div>
								<div className={styles["list"]}>
									{this.getInstructions()}
								</div>
							</div>
							{this.getSurveyQuestions()}
							<div className={styles["hr-line"]} />
							<div className={styles["action-buttons"]}>
								<div
									className={styles["cancel-button"]}
									onClick={() => this.closeSurvey()}
								>
									{getLabel('label_cancel_button')}
								</div>
								<div
									className={styles["send-button"]}
									onClick={this.openConfirmationBox}
								>
									{getLabel('label_send_button')}
								</div>
							</div>
						</div>
					</Dialog>
				) : (
						<Dialog
							overlayClassName={styles.submitteddialog}
							isFooterNeeded={isFooterNeeded}
						>
							<div className={styles["submitted-screen"]}>
								<div className={styles.message}>
									<img src={tickIcon} />
									<div>{getLabel('label_survey_thank_you_text')}</div>
									<div>
										{getLabel('label_survey_submitted_success_text')}
									</div>
								</div>
								<div
									className={styles.closeButton}
									onClick={() => this.saveAndCloseSurvey()}
								>
									{getLabel('label_continue_button')}
								</div>
							</div>
						</Dialog>
					)}
				{this.state.isConfirmationOpen ? (
					<Confirmation
						acceptButtonText={getLabel('label_submit_button')}
						confimationMessage={getLabel('label_survey_submit_confirmation')}
						onAcceptClick={this.sendAnswers}
						onCancelClick={this.closeConfirmationBox}
					/>
				) : null}
				{this.state.isErrorBoxOpen ? (
					<Confirmation
						confimationMessage={getLabel('label_survey_error_message')}
						onCancelClick={this.closeErrorBox}
						isErrorBox={true}
					/>
				) : null}
			</Fragment>
		);
	}
}

SurveyView.propTypes = {};

SurveyView.defaultProps = {};

export default SurveyView;



// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/SurveyView.js